import { Button } from "@progress/kendo-react-buttons";
import { ComponentMode, GetParentNode } from "../../../../common/RichTextEditorTools";
import { CreateComponentHtml, GetObjectFromHtml } from "../common/utilities";
import { createPortal } from "react-dom";
import { LearningObjectiveChecklistComponentDialog } from "./learningObjectiveChecklistComponentDialog";
import { getLearningObjectives } from "../../../../common/classifications/helperFunctions";

export const learningObjectiveChecklistClassName = "learningobjectivechecklist";

let learningObjectives: any[];

export class LearningObjectiveChecklistComponent {
  data?: string;

  constructor(value?: string) {
    this.data = value;
  }
}

// Create component
export const GetLearningObjectiveChecklistComponentFromHTML = (html: string): LearningObjectiveChecklistComponent => {
  const object = GetObjectFromHtml(html);
  return object.data ? new LearningObjectiveChecklistComponent(object.data) : new LearningObjectiveChecklistComponent();
};

export const GetHtmlFromLearningObjectiveChecklistComponent = async (
  item: LearningObjectiveChecklistComponent
): Promise<string> => {
  if (learningObjectives === undefined) learningObjectives = await getLearningObjectives();

  const data =
    "<p>[Checklist]</p>" +
      item.data
        ?.split("|")
        .map((identifier) => {
          const lo = learningObjectives.find((lo: any) => lo.identifier === identifier);
          return `<p>${lo ? `${lo.name} [${lo.levelId} ${lo.typeId}]` : "Okänt lärandemål"}</p>`;
        })
        .join("") || "";

  return CreateComponentHtml(learningObjectiveChecklistClassName, item, data);
};

// Tool Button
export const EditNodeToolLearningObjectiveChecklistComponent = (settings: any) => (props: any) => {
  const { view } = props;
  const mode = ComponentMode(view, learningObjectiveChecklistClassName);

  const handleSubmitEditLearningObjectiveChecklistComponent = (props: any) => {
    const { newNode, nodeAndPos } = props;
    const state = view!.state;
    const tr = state.tr.replaceWith(nodeAndPos.pos, nodeAndPos.pos + nodeAndPos.node.nodeSize, newNode);
    view!.dispatch(tr);
    settings.setEditLearningObjectiveChecklistComponent(null);
  };
  const handleCancelEditLearningObjectiveChecklistComponent = () => {
    settings.setEditLearningObjectiveChecklistComponent(null);
  };

  return (
    <>
      <Button
        onClick={() => {
          const state = view.state;
          const tr = state.tr;
          const nodeAndPos = GetParentNode(
            tr.doc,
            tr.selection.from,
            tr.selection.to,
            "str-component-" + learningObjectiveChecklistClassName,
            false
          );
          if (nodeAndPos) {
            settings.setEditLearningObjectiveChecklistComponent({ nodeAndPos });
          }
        }}
        togglable={true}
        onMouseDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.preventDefault()}
        title={mode === 1 ? "Ändra checklista" : "Infoga checklista"}
        icon="star-outline"
        selected={mode === 1}
        disabled={mode === -1}
      />
      {settings.editLearningObjectiveChecklistComponent &&
        createPortal(
          <LearningObjectiveChecklistComponentDialog
            {...settings.editLearningObjectiveChecklistComponent}
            editorSchema={view.state.schema}
            onSubmit={handleSubmitEditLearningObjectiveChecklistComponent}
            onCancel={handleCancelEditLearningObjectiveChecklistComponent}
            learningObjectives={settings.learningObjectives}
            learningObjectivesInLearningObject={settings.learningObjectivesInLearningObject}
            learningObjectUuid={settings.learningObjectUuid}
          />,
          document.body
        )}
    </>
  );
};
